/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';
import Button from '@vfuk/core-button';
import { internalLinkWrapperStyles } from './styles/CtaInternalLink.styles';

type InternalLinkProps = {
  label: string;
  href: string;
};

const CtaInternalLink = ({ label, href }: InternalLinkProps) => {

  const onClickHandler = () => {
    window.open(href, "_self");
  };

  return (
    <div css={internalLinkWrapperStyles}>
      <Button
        text={label}
        appearance="primary"
        onClick={onClickHandler}
      />
    </div>
  );
};

export default CtaInternalLink;
